import React from "react";
import { Link } from "react-router-dom";
import "./BrandSlider.css";
import { resolveAssetUrl } from "../utils/assets";

const BrandSlider = ({ data }) => {
  const brands = (data?.items || [])
    .map((item) => ({
      ...item,
      src: resolveAssetUrl(item.image) || item.image || "",
    }))
    .filter((item) => item.src);

  const repeatedBrands = [...brands, ...brands];

  return (
    <section className="brand-section">
      <div className="brand-header">
        {data?.subtitle && (
          <span className="brand-subtitle">{data.subtitle}</span>
        )}
        {data?.title && <h2>{data.title}</h2>}
        {data?.description && <p>{data.description}</p>}
      </div>

      <div className="brand-slider">
        <div className="brand-track">
          {repeatedBrands.map((brand, index) => {
            const img = (
              <img src={brand.src} alt={brand.alt || `Brand ${index + 1}`} />
            );
            return (
              <div className="brand-card" key={index}>
                {brand.link ? (
                  <Link to={brand.link.startsWith("/") ? brand.link : `/${brand.link}`}>
                    {img}
                  </Link>
                ) : (
                  img
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BrandSlider;
